export const SUPPORTED_COUNTRIES_TO_CURRENCIES: Record<string, string> = {
	// USD
	'US': 'usd', // United States

	// CAD
	'CA': 'cad', // Canada

	// GBP
	'GB': 'gbp', // United Kingdom

	// AUD
	'AU': 'aud', // Australia

	// EUR
	'AT': 'eur', // Austria
	'BE': 'eur', // Belgium
	'CY': 'eur', // Cyprus
	'EE': 'eur', // Estonia
	'FI': 'eur', // Finland
	'FR': 'eur', // France
	'DE': 'eur', // Germany
	'GR': 'eur', // Greece
	'HR': 'eur', // Croatia
	'IE': 'eur', // Ireland
	'IT': 'eur', // Italy
	'LV': 'eur', // Latvia
	'LT': 'eur', // Lithuania
	'LU': 'eur', // Luxembourg
	'MT': 'eur', // Malta
	'NL': 'eur', // Netherlands
	'PT': 'eur', // Portugal
	'SK': 'eur', // Slovakia
	'SI': 'eur', // Slovenia
	'ES': 'eur', // Spain

	// Other European countries
	'BG': 'bgn', // Bulgaria
	'CZ': 'czk', // Czech Republic
	'DK': 'dkk', // Denmark
	'HU': 'huf', // Hungary
	'LI': 'chf', // Liechtenstein
	'NO': 'nok', // Norway
	'PL': 'pln', // Poland
	'RO': 'ron', // Romania
	'SE': 'sek', // Sweden
	'CH': 'chf', // Switzerland
};
export const SUPPORTED_COUNTRIES = Object.keys(SUPPORTED_COUNTRIES_TO_CURRENCIES);
